/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ApproveLedgerWithdrawRequestOptions,
  ApproveLedgerWithdrawRequestStatus200,
  ApproveLedgerWithdrawRequestStatus400,
  ApproveLedgerWithdrawRequestStatus403,
  ApproveLedgerWithdrawRequestStatus404,
  ApproveLedgerWithdrawRequestStatus500,
} from '../types/ApproveLedgerWithdrawRequest'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { approveLedgerWithdrawRequest } from '../clients/approveLedgerWithdrawRequest'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const approveLedgerWithdrawRequestMutationKey = () =>
  [{ url: '/v1/ledger/withdraw/requests/:withdrawal_id/approve' }] as const

export function approveLedgerWithdrawRequestMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = approveLedgerWithdrawRequestMutationKey()
  return mutationOptions<
    ApproveLedgerWithdrawRequestStatus200,
    ResponseErrorConfig<
      | ApproveLedgerWithdrawRequestStatus400
      | ApproveLedgerWithdrawRequestStatus403
      | ApproveLedgerWithdrawRequestStatus404
      | ApproveLedgerWithdrawRequestStatus500
    >,
    ApproveLedgerWithdrawRequestOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return approveLedgerWithdrawRequest({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Approve a pending withdrawal request, allowing the transfer of assets to the outside world to proceed. Note that this does not interact with any external systems; it simply updates the status of the withdrawal request in the ledger. Actual transfer of assets must be handled separately.
 * @summary Approve a pending withdrawal request
 * {@link /v1/ledger/withdraw/requests/:withdrawal_id/approve}
 */
export function useApproveLedgerWithdrawRequest<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ApproveLedgerWithdrawRequestStatus200,
      ResponseErrorConfig<
        | ApproveLedgerWithdrawRequestStatus400
        | ApproveLedgerWithdrawRequestStatus403
        | ApproveLedgerWithdrawRequestStatus404
        | ApproveLedgerWithdrawRequestStatus500
      >,
      ApproveLedgerWithdrawRequestOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? approveLedgerWithdrawRequestMutationKey()

  const baseOptions = approveLedgerWithdrawRequestMutationOptions(config) as UseMutationOptions<
    ApproveLedgerWithdrawRequestStatus200,
    ResponseErrorConfig<
      | ApproveLedgerWithdrawRequestStatus400
      | ApproveLedgerWithdrawRequestStatus403
      | ApproveLedgerWithdrawRequestStatus404
      | ApproveLedgerWithdrawRequestStatus500
    >,
    ApproveLedgerWithdrawRequestOptions,
    TContext
  >

  return useMutation<
    ApproveLedgerWithdrawRequestStatus200,
    ResponseErrorConfig<
      | ApproveLedgerWithdrawRequestStatus400
      | ApproveLedgerWithdrawRequestStatus403
      | ApproveLedgerWithdrawRequestStatus404
      | ApproveLedgerWithdrawRequestStatus500
    >,
    ApproveLedgerWithdrawRequestOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ApproveLedgerWithdrawRequestStatus200,
    ResponseErrorConfig<
      | ApproveLedgerWithdrawRequestStatus400
      | ApproveLedgerWithdrawRequestStatus403
      | ApproveLedgerWithdrawRequestStatus404
      | ApproveLedgerWithdrawRequestStatus500
    >,
    ApproveLedgerWithdrawRequestOptions,
    TContext
  >
}
